import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { booleanBodyRender, TableColumn } from '@app/components/common/table';
import { DistributorSku } from '@app/api/models/sku';

export type DistributorSkuRow = DistributorSku & {
  distributor_name?: string;
  /** Только для колонки фильтра/отображения — берётся из sku_data */
  sku_code?: string;
  sku_title?: string;
};

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: DistributorSkuRow) => void;
}): TableColumn<DistributorSkuRow>[] => [
  {
    name: 'distributor_id',
    label: 'Дистрибьютор',
    options: {
      filter: {
        name: 'distributor_id',
        type: 'autocomplete',
        sourceName: 'distributor',
      },
      sort: false,
      customBodyRender: (_value, { rowData }) => {
        const id = rowData.distributor_id;
        const name = rowData.distributor_name;
        if (!id && id !== 0) {
          return '—';
        }
        return name ? `[${id}] ${name}` : `[${id}]`;
      },
    },
  },
  {
    name: 'distributor_sku_code',
    label: 'Код SKU',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_sku_code',
      },
      sort: false,
    },
  },
  {
    name: 'distributor_sku_title',
    label: 'Название SKU',
    options: {
      filter: {
        type: 'text',
        name: 'distributor_sku_title',
      },
      sort: false,
    },
  },
  {
    name: 'distributor_bar_code',
    label: 'Штрих-код',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'distributor_ean_code',
    label: 'EAN',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'distributor_unit',
    label: 'Ед.изм.',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'title_match_percentage',
    label: '% совпадения названия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: number | null | undefined) => (
        value === null || value === undefined ? '—' : String(value)
      ),
    },
  },
  {
    name: 'sku_id',
    label: 'Сопоставлен',
    options: {
      filter: {
        type: 'boolean',
        name: 'is_matched',
        label: 'Сопоставлен',
      },
      sort: false,
      customBodyRender: (_value, { rowData }) => {
        if (rowData.sku_data) {
          const { id, title } = rowData.sku_data;
          return title ? `[${id}] ${title}` : `[${id}]`;
        }
        return rowData.sku_id ? `[${rowData.sku_id}]` : 'Нет';
      },
    },
  },
  {
    name: 'sku_code',
    label: 'Код SKU (сопост.)',
    options: {
      filter: {
        type: 'text',
        name: 'sku_code',
        label: 'Код сопоставленного SKU',
      },
      sort: false,
      customBodyRender: (_value, { rowData }) => rowData.sku_data?.code || '—',
    },
  },
  {
    name: 'is_active',
    label: 'Активен',
    options: {
      filter: {
        type: 'boolean',
        name: 'is_active',
      },
      sort: false,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'id',
    label: 'Действия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_id, { rowData }) => (
        <Flex gap={2}>
          <IconButton
            name="edit"
            onClick={() => onEdit(rowData)}
            aria-label="edit"
          >
            <MdEdit />
          </IconButton>
        </Flex>
      ),
    },
  },
];
